(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_b78d0ab"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('perenn-magazine')) {
 customElements.define('perenn-magazine', class extends HTMLElement {
  connectedCallback() {
   this.abort = new AbortController();
   const signal = this.abort.signal;
   this.track = this.querySelector('.pm-track');
   this.prev = this.querySelector('[data-prev]');
   this.next = this.querySelector('[data-next]');
   this.current = this.querySelector('[data-current]');
   this.total = this.querySelector('[data-total]');
   this.index = 0;
   this.querySelector('.pm-controls').hidden = false;
   this.querySelector('.pm-arrows').hidden = false;
   const items = () => [...this.querySelectorAll('.pm-page')];
   this.items = items;
   this.position = el => el.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
   this.go = index => {
    const list = items();
    const target = list[Math.max(0, Math.min(list.length - 1, index))];
    if (target) this.track.scrollTo({left:this.position(target), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
   };
   this.update = () => {
    const list = items();
    this.index = list.reduce((best,el,i) => Math.abs(this.position(el)-this.track.scrollLeft) < Math.abs(this.position(list[best])-this.track.scrollLeft) ? i : best,0);
    this.current.textContent = String(list.length ? this.index+1 : 0).padStart(2,'0');
    this.total.textContent = String(list.length).padStart(2,'0');
    this.prev.disabled = this.index <= 0;
    this.next.disabled = this.index >= list.length-1;
   };
   this.prev.addEventListener('click', () => this.go(this.index-1), {signal});
   this.next.addEventListener('click', () => this.go(this.index+1), {signal});
   this.track.addEventListener('scroll', () => {
    cancelAnimationFrame(this.frame);
    this.frame=requestAnimationFrame(this.update);
   }, {signal,passive:true});
   this.track.addEventListener('keydown', e => {
    if (e.target !== this.track) return;
    if (['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) {
     e.preventDefault();
     this.go(e.key==='Home' ? 0 : e.key==='End' ? items().length-1 : this.index+(e.key==='ArrowRight' ? 1 : -1));
    }
   }, {signal});
   this.track.addEventListener('dragstart', e => e.preventDefault(), {signal});
   this.track.addEventListener('pointerdown', e => {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    this.drag = {id:e.pointerId,x:e.clientX,y:e.clientY,left:this.track.scrollLeft,moved:false};
   }, {signal});
   this.track.addEventListener('pointermove', e => {
    const d=this.drag;
    if (!d || e.pointerId!==d.id) return;
    const dx=e.clientX-d.x;
    if (!d.moved && Math.abs(dx)>8 && Math.abs(dx)>Math.abs(e.clientY-d.y)) {
     d.moved=true;
     this.track.setPointerCapture(e.pointerId);
     this.track.classList.add('pm-dragging');
    }
    if (d.moved) { e.preventDefault(); this.track.scrollLeft=d.left-dx; }
   }, {signal});
   const finish = e => {
    const d=this.drag;
    if (!d || e.pointerId!==d.id) return;
    this.drag=null;
    this.track.classList.remove('pm-dragging');
    if (d.moved) {
     this.suppressClick=true;
     clearTimeout(this.clickTimer);
     this.clickTimer=setTimeout(() => this.suppressClick=false,350);
     this.update();
     this.go(this.index);
    }
   };
   window.addEventListener('pointerup',finish,{signal});
   this.track.addEventListener('pointercancel',finish,{signal});
   this.track.addEventListener('click',e => {
    if(this.suppressClick) {e.preventDefault();e.stopPropagation();this.suppressClick=false;}
   }, {signal,capture:true});
   this.observer=new ResizeObserver(this.update);
   this.observer.observe(this.track);
   for (const image of this.querySelectorAll('img')) image.addEventListener('load',this.update,{signal});
   this.update();
  }
  disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); clearTimeout(this.clickTimer); }
 });
}
  } catch(e) { console.error(e); }
})();

})();
